import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  navigate() {
    window.open("www.yklaboratories.com")
  }

}
